import {
  AnalysisDetail,
  AnalysisListResponse,
  CreateAnalysisPayload,
  TokenUsage,
  UpdateAnalysisPayload,
} from '@/features/ChatBot/interfaces';

import { request } from '@/utils/request';
import { makeServerSideRequest } from '@/utils/serverSideRequest';

export const makeApi = (instance = request) => ({
  createAnalysis: (payload: CreateAnalysisPayload) =>
    instance.post<AnalysisDetail>('analysis/create/', payload),
  getAnalyses: (params?: { page?: number }) =>
    instance.get<AnalysisListResponse>('analysis/', { params }),
  getAnalysis: (id: number) => instance.get<AnalysisDetail>(`analysis/${id}/`),
  exportAnalysisPdf: (id: number) =>
    instance.get<Blob>(`analysis/${id}/export-pdf/`, { responseType: 'blob' }),
  updateAnalysis: (id: number, payload: UpdateAnalysisPayload) =>
    instance.patch(`analysis/${id}/edit/`, payload),
  deleteAnalysis: (id: number) => instance.delete(`analysis/${id}/delete/`),
  getTokenUsage: () => instance.get<TokenUsage>('ai-analysis/token-usage/'),
});

export const api = makeApi();
export const makeServerSideApi = (token?: string) => makeApi(makeServerSideRequest(token));
